import { render } from "./AccordionDetails.vue?vue&type=template&id=0e90376b&scoped=true"
import script from "./AccordionDetails.vue?vue&type=script&lang=js"
export * from "./AccordionDetails.vue?vue&type=script&lang=js"

import "./AccordionDetails.vue?vue&type=style&index=0&id=0e90376b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e90376b"]])

export default __exports__